import { LitElement, css, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { when } from 'lit/directives/when.js';
import { styles } from '../styles/single';
const { apiFetch } = window.wp;

export class Single extends LitElement {
  static get properties() {
    return {
      post: { type: Object, state: true },
      loading: { type: Boolean, state: true },
      ImageData: { type: Object, state: true },
      rowCount: { type: Number },
      columnCount: { type: Number },
    };
  }

  static get styles() {
    return styles;
  }

  constructor() {
    super();
    this.post = {};
    this.loading = true;
    this.ImageData = null;
  }

  convertHtmlTemplateTags(html) {

  }

  updated(changedProperties) {
    super.updated(changedProperties); // Call the super method
    if (changedProperties.has('post') && this.post.id) {
      this.loading = true;

      //get media from post.featured_media_url
      this.loadMedia(this.post.featured_media)
        .then((media) => {
          this.ImageData = media;
          this.loading = false;
        })
        .catch((error) => {
          console.error('Failed to load media:', error);
          this.loading = false;
        });
    }
  }

  async loadMedia(id) {
    return apiFetch({
      path: `/wp/v2/media/${id}`,
      method: 'GET',
    })
      .then((response) => {
        return response; // Return the fetched media response
      })
      .catch((error) => {
        throw error; // Rethrow the error to be caught in the caller
      });
  }

  replaceTags(html) {
   
    return html.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
      return '&#'+i.charCodeAt(0)+';';
   });
  }
  

  renderNoImage() {
    console.log(replaceTags(this.post.title.rendered));
    return html`
      <div class="card-noimage">
        <div class="card-img_container">
          <img
            src="https://www.edenco.se/wp-content/uploads/2024/02/cropped-eden_favicon.png"
          />
        </div>
        <div class="card-content">
          <h2>${replaceTags(this.post.title.rendered)}</h2>
          <div>
            <p>${this.post.short_desc}</p>
            <a class="btn" href="${this.post.link}">Läs mer</a>
          </div>
        </div>
      </div>
    `;
  }

  renderWithImage() {
    return html`
      <div class="card">
        <div class="card-img_container">
          <img
            src="${this.ImageData.source_url}"
            alt="${this.ImageData.alt_text}"
          />
        </div>
        <div class="card-content">
          <h2>${this.post.title.rendered}</h2>
          <div>
            <p>${this.post.short_desc}</p>
            <div>
              <a class="btn" href="${this.post.link}">Läs mer</a>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  render() {
    if (this.loading) return html`<div class="loading"></div>`;

    return html`
      ${when(
        this.ImageData,
        () => this.renderWithImage(),
        () => this.renderNoImage()
      )}
    `;
  }
}
